import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useLocation } from "react-router-dom";

import { NAV_MENU_ITEMS } from "src/library/constants";
import { RoutesEnum } from "src/library/types/types";
import { NavMenuEnum } from "src/library/types/types";
import { LinkToRegisterButton, EntainLogoButton } from "src/library/components/exports";
import NavMenuItem from "./NavMenuItem";
import { useHackathonContext } from "src/library/store/GlobalStateProvider";

export default function DesktopHeaderLinks() {
  const { state } = useHackathonContext();
  const { pathname } = useLocation();
  const isRegisterPage = pathname === RoutesEnum.Register ? true : false;

  return (
    <Stack
      component="nav"
      direction="row"
      justifyContent="center"
      sx={{ width: "90vw", mx: "auto", minWidth: "1030px" }}
    >
      <Box sx={{ position: "absolute", top: 0, left: 75, width: "auto", height: "auto" }}>
        <EntainLogoButton section={NavMenuEnum.Home} />
      </Box>
      <List sx={{ display: "flex" }}>
        {NAV_MENU_ITEMS.map((section, index) => (
          <ListItem
            disablePadding
            key={`desktop-nav-item-${index}`}
            sx={{ width: "auto" }}
          >
            <NavMenuItem section={section} />
          </ListItem>
        ))}
      </List>
      {!isRegisterPage && state.registrationsAvailable && (
        <Box sx={{ position: "absolute", top: 10, right: 20 }}>
          <LinkToRegisterButton buttonText="Register" size="small" />
        </Box>
      )}
    </Stack>
  );
}
